import axios from "axios";
import config from "../../config";

const BASE_API = config.BASE_API;

const salvar = (parametro) => {
  return axios.post(BASE_API + "bloqueios/agendamento/", parametro);
};

const getAgendamento = () => axios.get(BASE_API + "bloqueios/agendamento");

const getUsuariosParaBloqueio = (mes, ano) =>
  axios.get(`${BASE_API}bloqueios/lista-bloqueio`, {
    params: { mes, ano },
  });

const getReport = async (params) => {
  return axios
    .get(`${BASE_API}bloqueios/desbloqueados/relatorio`, {
      params,
      responseType: "blob",
    })
    .then((resp) => resp.data)
    .catch((error) => {
      if (error.response) {
        const mensagemErro =
          error.response.data?.message || "Erro desconhecido.";
        return Promise.reject(mensagemErro);
      } else {
        return Promise.reject("Erro ao gerar relatório: Problema de conexão.");
      }
    });
};

const getReportDocx = async (params) => {
  const url = `${BASE_API}bloqueios/desbloqueados/relatorio-word`;

  return axios
    .get(`${BASE_API}bloqueios/desbloqueados/relatorio-word`, {
      params,
      responseType: "blob",
    })
    .then((resp) => resp.data)
    .catch((error) => {
      if (error.response) {
        const mensagemErro =
          error.response.data?.message || "Erro desconhecido.";
        return Promise.reject(mensagemErro);
      } else {
        return Promise.reject("Erro ao gerar relatório: Problema de conexão.");
      }
    });
};

const getReportCsv = async (params) => {
  const url = `${BASE_API}bloqueios/desbloqueados/relatorio-csv`;

  return axios
    .get(`${BASE_API}bloqueios/desbloqueados/relatorio-csv`, {
      params,
      responseType: "blob",
    })
    .then((resp) => resp.data)
    .catch((error) => {
      if (error.response) {
        const mensagemErro =
          error.response.data?.message || "Erro desconhecido.";
        return Promise.reject(mensagemErro);
      } else {
        return Promise.reject("Erro ao gerar relatório: Problema de conexão.");
      }
    });
};

const sendEmail = async (params) => {
  try {
    const response = await axios.post(
      `${BASE_API}bloqueios/desbloqueados/enviar-email`,
      null,
      { params }
    );
    return response;
  } catch (error) {
    if (error.response) {
      const mensagemErro = error.response.data?.message || "Erro desconhecido.";
      return Promise.reject(mensagemErro);
    } else if (error.request) {
      return Promise.reject(
        "Erro ao gerar relatório e Enviar E-mail: Problema de conexão."
      );
    } else {
      return Promise.reject("Erro desconhecido.");
    }
  }
};

const getUnlockDates = () => {
  return {
    dataInicio: "01/02/2002",
    dataFim: "01/03/2005",
  };
};

export const efetuarBloqueio = (tipo, listaBloqueio) => {
  return axios
    .post(
      `${BASE_API}bloqueios/efetuar-bloqueio`,
      {
        tipo,
        listaBloqueio,
      },
      {
        responseType: "blob",
      }
    )
    .then((resp) => resp.data)
    .catch(async (error) => {
      if (error.response && error.response.data) {
        try {
          const blob = error.response.data;
          const text = await blob.text();
          const json = JSON.parse(text);
          const mensagemErro = json.message || "Erro desconhecido.";
          return Promise.reject(mensagemErro);
        } catch (e) {
          return Promise.reject("Erro ao interpretar a resposta de erro.");
        }
      } else {
        return Promise.reject("Erro ao gerar relatório: Problema de conexão.");
      }
    });
};

export const emitirRelatorioBloqueio = (tipo, listaBloqueio) => {
  return axios
    .post(
      `${BASE_API}bloqueios/emitir-relatorio-bloqueio`,
      {
        tipo,
        listaBloqueio,
      },
      {
        responseType: "blob",
      }
    )
    .then((resp) => resp.data)
    .catch(async (error) => {
      if (error.response && error.response.data) {
        try {
          const blob = error.response.data;
          const text = await blob.text();
          const json = JSON.parse(text);
          const mensagemErro = json.message || "Erro desconhecido.";
          return Promise.reject(mensagemErro);
        } catch (e) {
          return Promise.reject("Erro ao interpretar a resposta de erro.");
        }
      } else {
        return Promise.reject("Erro ao gerar relatório: Problema de conexão.");
      }
    });
};

const getListHistoricoBloqueio = async (params) => {
  return axios.get(`${BASE_API}bloqueios/lista-historicoBloqueio`, {
    params,
  });
};

const getListaBloqueadosPorHistorico = async (id) => {
  return axios.get(`${BASE_API}bloqueios/lista-bloqueioPorHistorico/` + id, {});
};

export default {
  salvar,
  getAgendamento,
  getUnlockDates,
  getReport,
  sendEmail,
  getReportDocx,
  getReportCsv,
  getUsuariosParaBloqueio,
  efetuarBloqueio,
  getListHistoricoBloqueio,
  getListaBloqueadosPorHistorico,
  emitirRelatorioBloqueio,
};
